import { useContext } from 'react';
import { UserContext } from '../../context';
import { useCryptoWallets } from '../useCryptoWallets';
import { useFiatExchange } from '../useFiatExchange';
import { useWalletCurrency } from '../useWalletCurrency';

export const useGetCurrentBalance = () => {
  const [user] = useContext(UserContext);
  const { activeWallet = {} } = user;
  const { deposit } = activeWallet;
  const { baseBalance, bonusBalance } = useCryptoWallets();
  const walletCurrency = useWalletCurrency();
  const { convertToFiat } = useFiatExchange();

  if (!walletCurrency) {
    return deposit;
  }

  return convertToFiat(
    parseFloat(baseBalance) + parseFloat(bonusBalance),
    walletCurrency
  );
};
